import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin, Select } from 'antd'
import { Column } from '@antv/g2plot';
import Card from '@/pages/Tbqy/components/components/Card'
import * as api from '@/api/tbyqy'
import { jeOptions } from '@/utils/options'
import styles from '@/pages/Tbqy/style.module.less'

const data = [];

for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "月",
    "type": "本年",
    "value": 0
  })
  data.push({
    "label": i+ 1 + "月",
    "type": "上年",
    "value": 0
  })
}

const tabsOptions = [
  {
    label: '签约额', 
    value: 'qyhtHJ',
    api: api.getQysjtjAsjQye,
    totalText: '签约额合计（万元）'
  },
  {
    label: '签约数', 
    value: 'qyhtnum',
    api: api.getQysjtjAsjQys,
    totalText: '签约数合计'
  }, 
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const [title, setTitle] = useState(tabsOptions[0].totalText)
  const [tabValue, setTabValue] = useState(tabsOptions[0].value)
  const [total, setTotal] = useState({
    qn: 0,
    jn: 0
  })
  const containerRef = useRef()
  const globalRef = useRef({
    activeTab: tabsOptions[0].value,
    column: null as Column,
    je: '0',
    sfay: 'N'
  })

  useEffect(() => {
    globalRef.current.column = new Column(containerRef.current, {
      data,
      xField: 'label',
      yField: 'value',
      seriesField: 'type',
      isGroup: true,
      legend: {
        position: 'bottom',
      },
      columnStyle: {
      }
    });

    globalRef.current.column.render();
  }, [])

  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.activeTab)
    if(!tabOption) {
      return
    }
    const res = await tabOption.api({sfay: globalRef.current.sfay})
    if(res.success) {
      setTotal({
        jn: res.data.jnnum || res.data.jnHJ || 0,
        qn: res.data.qnnum || res.data.qnHJ || 0
      })
      let allData = res.data.list
      if(globalRef.current.activeTab === 'qyhtHJ') {
        const filterFn = jeOptions.find(r => r.value === globalRef.current.je) 
        if(filterFn.filter) {
          allData = allData.filter(r => filterFn.filter(r.jnHJ))
        }
      }
      globalRef.current.column.changeData(allData.reduce((c, n) => {
        c.push({
          label: n['月份'],
          value: n.jnHJ || n.jnnum || 0,
          type: '今年',
        })
        c.push({
          label: n['月份'],
          value: n.qnHJ || n.qnnum || 0,
          type: '去年'
        })
        return c
      }, []))
      globalRef.current.column.update(globalRef.current.activeTab !== 'qyhtnum' ? {
        yAxis: {
          label: {
            formatter: (val) => `${val} 万元`,
          }
        },
        tooltip: {
          formatter: (datum) => {
            return {
              name: datum.type,
              value: `${datum.value}万元`,
            };
          },
        }
      } : {
        yAxis: {
          label: {
            formatter: (val) => val,
          }
        },
        tooltip: {
          formatter: (datum) => {
            return {
              name: datum.type,
              value: datum.value,
            };
          },
        }
      })
    }
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.activeTab = value
    setTabValue(value)
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.activeTab)
    setTitle(tabOption.totalText)
    getList()
  }, [getList])

  const handleJeChange = useCallback((val) => {
    globalRef.current.je = val
    getList()
  }, [getList])

  const handleTjfw = useCallback((val) => {
    globalRef.current.sfay = val
    getList()
  }, [getList])

  useEffect(() => {
    getList()
  }, [updateTime, getList])

  return (
    <Spin spinning={loading}>
      <Card title="签约数据统计（按时间）" tabs={tabsOptions} onTabChange={handleTabChange}>
        <div className={`flex flex-column ${styles['tb-sj']}`}>
          <div className='flex'>
            {
              tabValue === 'qyhtHJ' && (
                <div className='mb-10'>
                  金额：<Select
                    defaultValue="0"
                    style={{width: '120px'}}
                    onChange={handleJeChange}
                    options={jeOptions}
                  />
                </div>
              )
            }
          </div>
          <div className='flex'>
            <div className={`text-center ${styles['tb-sj-left']}`}>
              <div className='text-777 mt-30'>本年{title}</div>
              <div className='font-30 text-primary mt-7'>{total.jn}</div>
              <div className='text-777 mt-30'>上年{title}</div>
              <div className='font-30 mt-7'>{total.qn}</div>
            </div>
            <div className='flex-1 w-0 ml-10'>
              <div className='h-full' ref={containerRef}></div>
            </div>
          </div>
        </div>
      </Card>
    </Spin>
  )
}

export default Component
